export const PostalCodeModelData = function () {
  return {
    success: null,
    postalCodeList: [],
    jurisdictionPostalCodeList: []
  }
}
